"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var last_1 = __importDefault(require("lodash/last"));

var first_1 = __importDefault(require("lodash/first"));

var React = __importStar(require("react"));

var BaseCalendarView_1 = __importDefault(require("./BaseCalendarView"));

var Calendar_1 = __importDefault(require("./Calendar"));

var Body_1 = __importDefault(require("./CalendarBody/Body"));

var Header_1 = __importDefault(require("./CalendarHeader/Header"));

var lib_1 = require("../lib");

var YEAR_CALENDAR_ROW_WIDTH = 3;

var YearView =
/** @class */
function (_super) {
  __extends(YearView, _super);

  function YearView() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  YearView.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        values = _a.values,
        onNextPageBtnClick = _a.onNextPageBtnClick,
        onPrevPageBtnClick = _a.onPrevPageBtnClick,
        onValueClick = _a.onValueClick,
        hasNextPage = _a.hasNextPage,
        hasPrevPage = _a.hasPrevPage,
        onHeaderClick = _a.onHeaderClick,
        disabledItemIndexes = _a.disabledItemIndexes,
        activeItemIndex = _a.activeItemIndex,
        hoveredItemIndex = _a.hoveredItemIndex,
        onCellHover = _a.onCellHover,
        onMount = _a.onMount,
        inline = _a.inline,
        localization = _a.localization,
        rest = __rest(_a, ["values", "onNextPageBtnClick", "onPrevPageBtnClick", "onValueClick", "hasNextPage", "hasPrevPage", "onHeaderClick", "disabledItemIndexes", "activeItemIndex", "hoveredItemIndex", "onCellHover", "onMount", "inline", "localization"]);

    var headerTitle = first_1.default(values) + " - " + last_1.default(values);
    return React.createElement(Calendar_1.default, __assign({
      ref: function ref(e) {
        return _this.calendarNode = lib_1.findHTMLElement(e);
      },
      outlineOnFocus: inline
    }, rest), React.createElement(Header_1.default, {
      className: 'suicr-year-view-header',
      title: headerTitle,
      onNextPageBtnClick: onNextPageBtnClick,
      onPrevPageBtnClick: onPrevPageBtnClick,
      hasNextPage: hasNextPage,
      hasPrevPage: hasPrevPage,
      onHeaderClick: onHeaderClick,
      width: YEAR_CALENDAR_ROW_WIDTH,
      displayWeeks: false,
      localization: localization
    }), React.createElement(Body_1.default, {
      width: YEAR_CALENDAR_ROW_WIDTH,
      data: values,
      hovered: hoveredItemIndex,
      onCellHover: onCellHover,
      onCellClick: onValueClick,
      active: activeItemIndex,
      disabled: disabledItemIndexes
    }));
  };

  return YearView;
}(BaseCalendarView_1.default);

exports.default = YearView;